import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

// action types
export const LOGOMARCA = "logomarca";
export const LOGIN = "login";
export const LOGOUT = "logout";
export const GET_TOKEN_REGISTER = "getTokenRegister";
export const GET_VERIFICA_EMAIL_EM_USO = "getVerificarEmailEmUso";
export const GET_VERIFICA_CELULAR_EM_USO = "getVerificarCelularEmUso";
export const POST_REGISTRAR_CONTA = "postRegistrarConta";
export const GET_RECUPERAR_SENHA = "getRecuperarSenha";
export const GET_RECUPERAR_SENHA_SMS = "getRecuperarSenhaSMS";

// mutation types
export const PURGE_AUTH = "logOut";
export const SET_AUTH = "setUser";
export const SET_ERROR = "setError";

const state = {
    erros: null,
    user: {},
    isAuthenticated: !!JwtService.getToken()
};

const getters = {
    currentUser(state) {
        return state.user;
    }
};

const actions = {
    async [LOGOMARCA](context, dados) {
        let retorno = await ApiService.post("logomarca", dados);
        return retorno.data;
    },
    async [LOGIN](context, credentials) {
        let retorno = await ApiService.post("login", credentials);
        return retorno.data;
    },
    [LOGOUT](context) {
        context.commit(PURGE_AUTH);
    },
    async [GET_TOKEN_REGISTER](context, tokenRegister) {
        let retorno = await ApiService.post("tokenRegister", { tokenRegister: tokenRegister });
        return retorno.data;
    },
    async [GET_VERIFICA_EMAIL_EM_USO](context, dados) {
        let retorno = await ApiService.post("verificarEmailEmUso", dados);
        return retorno.data;
    },
    async [GET_VERIFICA_CELULAR_EM_USO](context, dados) {
        let retorno = await ApiService.post("verificarCelularEmUso", dados);
        return retorno.data;
    },
    async [POST_REGISTRAR_CONTA](context, conta) {
        let retorno = await ApiService.post("registrarConta", conta);
        return retorno.data;
    },
    async [GET_RECUPERAR_SENHA](context, dados) {
        let retorno = await ApiService.post("recuperarSenha", dados);
        return retorno.data;
    },
    async [GET_RECUPERAR_SENHA_SMS](context, dados) {
        let retorno = await ApiService.post("recuperarSenhaSMS", dados);
        return retorno.data;
    }
};

const mutations = {
    [SET_ERROR](state, error) {
        state.errors = error;
    },
    [SET_AUTH](state, user) {
        state.isAuthenticated = true;
        state.errors = {};

        if (user.token) {
            state.user = user;
            JwtService.saveToken(state.user.token);
        }
    },
    [PURGE_AUTH](state) {
        state.isAuthenticated = false;
        state.user = {};
        state.errors = {};
        JwtService.destroyToken();
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};